import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content"]

  connect() {
    // Move content to body so it escapes any parent stacking contexts
    // (e.g. sticky sidebars, positioned headers)
    this._content = this.contentTarget
    document.body.appendChild(this._content)

    // Delegate close clicks since content is outside controller scope
    this._handleClose = (e) => {
      if (e.target.closest("[data-dialog-close]")) this.close()
    }
    this._content.addEventListener("click", this._handleClose)

    if (this.element.dataset.dialogAutoOpen === "true") {
      requestAnimationFrame(() => this.open())
    }
  }

  open() {
    this._content.classList.remove("hidden")
    this._content.classList.add("flex")
    document.body.style.overflow = "hidden"
    this.boundKeydown = this.keydown.bind(this)
    document.addEventListener("keydown", this.boundKeydown)
    this.dispatch("open")

    requestAnimationFrame(() => {
      this._content.querySelector(".ProseMirror")?.focus()
    })
  }

  close() {
    this._content.classList.add("hidden")
    this._content.classList.remove("flex")
    document.body.style.overflow = ""
    if (this.boundKeydown) {
      document.removeEventListener("keydown", this.boundKeydown)
    }
  }

  keydown(event) {
    if (event.key === "Escape") {
      this.close()
    }
  }

  disconnect() {
    if (this._content) {
      this._content.removeEventListener("click", this._handleClose)
      this._content.remove()
    }
    document.body.style.overflow = ""
    if (this.boundKeydown) {
      document.removeEventListener("keydown", this.boundKeydown)
    }
  }
}
